module.exports = __webpack_public_path__ + "assets/media/FormSubmission.2e5fd50f.svg";